import React from 'react';

const CodeHFormSection = ({
    canWrite,
    handleAdd,
    handleHSave,
    selectCodeH,
    handleHChange,
    handleDuplH,
    duplHMsg,
    useYnOptions
}) => {
    return (
        <section className="wp25">
            <div className="section-tit-wrap">
                <h3 className="border-left-primary !text-[19px] md:!text-[21px]">&nbsp;공통코드(H) 등록</h3>
                <div className="btn-right-box">
                    <ul>
                        {canWrite && <li><button type="button" title="추가" className="btn-add" id="btn-add01" onClick={() => handleAdd("h")}>추가</button></li>}
                        {canWrite && <li><button type="button" title="저장" className="btn-save" id="btn-save01" onClick={handleHSave}>저장</button></li>}
                    </ul>
                </div>
            </div>

            {/* Mobile: 카드형 폼 */}
            <div className="md:hidden rounded-xl border border-gray-200 bg-white p-4 shadow-sm space-y-4">
                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">그룹코드<span className="red">*</span></label>
                    <input
                        name="comhCode"
                        value={selectCodeH.comhCode || ""}
                        onChange={handleHChange}
                        className="w-full min-w-0 rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                    />
                    <button
                        type="button"
                        className="btn-search w-full mt-2"
                        onClick={handleDuplH}
                        disabled={selectCodeH.isNew ? false : true}
                    >
                        중복확인
                    </button>
                    {selectCodeH.isNew && (
                        <p className="mt-1 text-[13px] text-gray-600">{duplHMsg}</p>
                    )}
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">그룹명<span className="red">*</span></label>
                    <input
                        name="comhName"
                        value={selectCodeH.comhName || ""}
                        onChange={handleHChange}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                    />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">정렬 순서<span className="red">*</span></label>
                        <input
                            name="hsort"
                            value={selectCodeH.hsort || ""}
                            onChange={handleHChange}
                            type="number"
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px]"
                        />
                    </div>
                    <div>
                        <label className="block text-[14px] font-bold text-gray-700 mb-1">사용여부<span className="red">*</span></label>
                        <select
                            name="huseYn"
                            value={selectCodeH.huseYn || ""}
                            onChange={handleHChange}
                            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px] bg-white"
                        >
                            {useYnOptions.map((data) => (
                                <option key={data.key} value={data.key}>{data.name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-[14px] font-bold text-gray-700 mb-1">비고</label>
                    <textarea
                        name="hnotice"
                        value={selectCodeH.hnotice || ""}
                        onChange={handleHChange}
                        className="w-full rounded-lg border border-gray-200 px-3 py-2 text-[16px] min-h-[96px] resize-none"
                    />
                </div>
            </div>

            {/* Desktop: 기존 테이블 */}
            <div className="hidden md:block table-container overflow-x-auto [-webkit-overflow-scrolling:touch]">
                <table className="table-write !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '70%' }} />
                    </colgroup>
                    <tbody id="tblBody1">
                        <tr>
                            <th>그룹코드<span className="red">*</span></th>
                            <td>
                                <div className="flex flex-col xl:flex-row gap-2">
                                    <input
                                        name="comhCode"
                                        value={selectCodeH.comhCode || ""}
                                        onChange={handleHChange}
                                        className="input-search"
                                        style={{ width: "100%", maxWidth: "none" }}
                                    />
                                    <button type="button" className="btn-search" id="duplCodeH"
                                        onClick={handleDuplH} disabled={selectCodeH.isNew ? false : true}>중복확인</button>
                                </div>
                                <label style={{ display: selectCodeH.isNew ? "" : "none" }}>{duplHMsg}</label>
                            </td>
                        </tr>
                        <tr>
                            <th>그룹명<span className="red">*</span></th>
                            <td>
                                <input
                                    name="comhName"
                                    value={selectCodeH.comhName || ""}
                                    onChange={handleHChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>정렬 순서<span className="red">*</span></th>
                            <td>
                                <input
                                    name="hsort"
                                    value={selectCodeH.hsort || ""}
                                    onChange={handleHChange}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                    type="number"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>사용여부<span className="red">*</span></th>
                            <td>
                                <select
                                    name="huseYn"
                                    value={selectCodeH.huseYn || ""}
                                    className="input-search"
                                    style={{ width: '100%', maxWidth: 'none' }}
                                    onChange={handleHChange}
                                >
                                    {useYnOptions.map((data) => (
                                        <option key={data.key} value={data.key}>{data.name}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>비고</th>
                            <td>
                                <textarea
                                    name="hnotice"
                                    value={selectCodeH.hnotice || ""}
                                    onChange={handleHChange}
                                    style={{
                                        width: '100%', height: '100px', resize: 'none',
                                        wordWrap: 'break-word', whiteSpace: 'pre-wrap', borderColor: "#CCC"
                                    }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </section>
    );
};

export default CodeHFormSection;
